import { useState, useEffect } from "react";

export default function StickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`sticky-cta-bar${visible ? " visible" : ""}`} data-testid="sticky-cta-bar">
      <div className="sticky-cta-left">
        <span className="sticky-cta-title">Ready to claim?</span>
        <span className="sticky-cta-sub">No Win, No Fee** &bull; SRA Regulated</span>
      </div>
      <a href="https://sa.yoursolicitor.co.uk/claim" className="sticky-cta-btn" data-testid="sticky-cta-btn" data-ratifi-forward>
        Find My Agreements <span className="arrow">&rarr;</span>
      </a>
    </div>
  );
}
